export default __webpack_public_path__ + "static/media/ts-4-4.13032daf.svg";